import {Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {
    Button,
    DateInput,
    FormDataConsumer,
    FormWithRedirect,
    required,
    SelectInput,
    TextInput,
    useCreate,
    useNotify,
    useRecordContext,
    useRefresh,
} from "react-admin";
import {FormSaveButton} from "../../components/FormSaveButton";
import {useOptions} from "../../shared/hooks/useOptions";
import {useToggler} from "../../shared/hooks/useToggler";
import {dateFormatter, generateError, initInput} from "../../shared/utils";
import IconCancel from "@material-ui/icons/Cancel";
import {NumberInput} from "../../components/NumberInput";
import {useCallback} from "react";
import {ReferenceInputBank} from "../../components/reference-inputs/ReferenceInputBank";

export const AddPurchasePaymentStatusButton = () => {
    const record = useRecordContext();
    const {data: termsPayment} = record.terms_payment
    const {value, setFalse, setTrue} = useToggler();
    const refresh = useRefresh();
    const [create, {loading}] = useCreate();
    const notify = useNotify();
    const handleSubmit = (values: any) => {
        create("payment_schedule_status", values, {
            onSuccess: (data) => {
                setFalse();
                refresh();
            },
            onFailure: (error) => {
                generateError(error, notify);
            },
        });
    };
    const paymentStatusChoices = useCallback(() => {
        if (termsPayment && termsPayment.method_code === "MP12")
            return [
                {value: "NE", display_name: "Non emessa"},
                {value: "E", display_name: "Emessa"},
                {value: "IN", display_name: "Insoluta"},
            ];
        return [
            {value: "I", display_name: "Fattura pagata"},
            {value: "A", display_name: "Acconto"},
            {value: "S", display_name: "Sollecito ricevuto"},
        ];
    }, [termsPayment]);
    const {data: options} = useOptions("payment_schedule_status", "POST");
    return options ? (
        <>
            <Button
                variant="outlined"
                label="Aggiorna stato"
                onClick={() => setTrue()}
            ></Button>
            <Dialog open={value} maxWidth="sm" fullWidth>
                <FormWithRedirect
                    resource="payment_schedule_status"
                    save={handleSubmit}
                    initialValues={{payment_schedule: record.id, payment_schedule_id: record.id}}
                    render={({handleSubmitWithRedirect, pristine, saving}) => (
                        <>
                            <DialogContent>
                                <DateInput
                                    initialValue={dateFormatter(new Date())}
                                    {...initInput("date", options, true)}
                                />
                                <SelectInput
                                    {...initInput("status", options, true, "array")}
                                    choices={paymentStatusChoices()}
                                />
                                <FormDataConsumer>
                                    {({formData}) => (
                                        <>
                                            {formData.status === "A" && (
                                                <NumberInput
                                                    {...initInput("amount", options, true)}
                                                    validate={[required()]}
                                                />
                                            )}
                                            {
                                                ["A", "I"].includes(formData.status) && (
                                                    <SelectInput
                                                        {...initInput(
                                                            "collection_type",
                                                            options,
                                                            true,
                                                            "array"
                                                        )}
                                                        choices={options.collection_type.choices}
                                                        validate={[required()]}
                                                    />
                                                )
                                            }
                                            {
                                                ["A", "I"].includes(formData.status) && (
                                                    <ReferenceInputBank {...initInput("bank_id", options, true)} label="Banca" defaultValue={1} />
                                                )
                                            }
                                        </>
                                    )}
                                </FormDataConsumer>
                                <TextInput {...initInput("notes", options, true)} />

                            </DialogContent>
                            <DialogActions>
                                <Button label="ra.action.cancel" onClick={setFalse}>
                                    <IconCancel/>
                                </Button>
                                <FormSaveButton
                                    handleSubmit={() => handleSubmitWithRedirect!()}
                                    submitting={loading}
                                    pristine={false}
                                    label="Crea"
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    ) : null;
};
